module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/3_52be7c92cc65865b64959ebdf7559fd7.png";